"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.loadEnvFile = void 0;
const common_1 = require("./common");
const LoadOptions_1 = require("./LoadOptions");
window.env = window.env || {};
const loadEnvFile = (path) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(path);
    const text = yield res.text();
    if (text.startsWith("<")) {
        throw new Error("Invalid .env file. Looks like default HTML file.");
    }
    else {
        return text;
    }
});
exports.loadEnvFile = loadEnvFile;
const load = (options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const opt = Object.assign(Object.assign({}, LoadOptions_1.browserDefaultLoadOptions), options);
    try {
        const dotenvStr = yield exports.loadEnvFile(opt.path);
        return common_1._appendEnv(dotenvStr, window, options.validator);
    }
    catch (e) {
        if (opt.failSilently) {
            return {};
        }
        else {
            throw e;
        }
    }
});
exports.load = load;
exports.default = exports.load;
//# sourceMappingURL=browser.js.map